import { Wrapper } from "./wrapper";
import { Input } from "./input";
import { Selection } from "./selection";
import { TextArea } from "./textarea";
import { CalendarRange, CalendarSelect } from "./calendar";
import { Password } from "./password";
import { Divider } from "./divider";

export const Edit = Object.assign(Wrapper, {
  Input,
  Selection,
  TextArea,
  CalendarRange,
  CalendarSelect,
  Password,
  Divider,
});

export { buildFilterObject } from "./selection";
// TYPES
export type { SelectionItemProps as EditSelectionItemProps } from "./selection";
export { formatDay } from "./calendar";
